import React from 'react'

import { SearchModal } from '../common/search'
import { NavBar } from '../common'
import HomeHeaderBox from './HomeHeaderBox'
import { Icon, Box } from '../common'
import { Spirit } from '../../styles/spirit-styles'

// Custom headings must be React components. You should include the <NavBar /> component
// somewhere in it. You can optionally set the theme of the navbar to `dark` or `light`.
const HomeHeader = () => (
    <div className="gh-bg-home bb b--whitegrey">
        <header className="top-0 left-0 right-0 z-9999">
            <NavBar theme="light" />
        </header>
        <div className={`${Spirit.page.xl} pb5 pt10 pt15-ns pt20-l pb10-ns pb15-l flex flex-column items-center bt bn-ns b--white-10`}>
            <h1 className="ma0 pa0 f2 f1-ns f-headline-l white header-heading-shadow">Documentation</h1>
            <SearchModal isHome />

            <section className={`${Spirit.page.xl} col-12 mt8 bt bn-ns b--whitegrey pt5 pt0-ns home-main-box-margin-ns`}>
                <div className="grid-integrations-index mt4 mt6-l f8">
                    {/* <Box to="/listpro" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/mstore-web.png" alt="MStore Magento" />
                        Mstore Web
                    </Box> */}
                    <Box to="/fluxbuilder" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/fluxbuilder.png" alt="Fluxbuilder" />
                        Fluxbuilder
                    </Box> 

                    <Box to="/fluxnews" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/fluxnews.png" alt="FluxNews" />
                        FluxNews
                    </Box>

                    <Box to="/fluxstore" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/fluxstore.png" alt="Fluxstore" />
                        Fluxstore
                    </Box>

                
                    <Box to="/mstore" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/mstore.png" alt="MStore" />
                        MStore Pro
                    </Box>

                    <Box to="/beonews" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/beonews.png" alt="MStore Magento" />
                        Beonews Pro
                    </Box>

                    <Box to="/listapp" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/listapp.png" alt="MStore Magento" />
                        ListApp
                    </Box>

                    <Box to="/mstore-magento" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/mstore-magento.png" alt="MStore Magento" />
                        MStore Magento
                    </Box>

                    {/* <Box to="/mstore-mv" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/mstore.png" alt="MStore Magento" />
                        MStore Multi Vendor
                    </Box> */}

                    {/* <Box to="/evastore" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/evastore.png" alt="MStore Magento" />
                        Evastore
                    </Box> */}

                    {/* <Box to="/cestore" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/cestore.png" alt="MStore Magento" />
                        CeStore
                    </Box> */}

                    {/* <Box to="/buzzapp" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/buzzapp.png" alt="MStore Magento" />
                        Buzzapp
                    </Box> */}

                    {/* <Box to="/cestore-web" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/cestore.png" alt="MStore Magento" />
                        CeStore Web
                    </Box> */}

                    {/* <Box to="/listpro" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/listpro.png" alt="MStore Magento" />
                        ListPro
                    </Box>

                    <Box to="/reactxs" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/reactxs.png" alt="MStore Magento" />
                        ReactXS
                    </Box>

                    <Box to="/beonboard" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/beonboard.png" alt="MStore Magento" />
                        BeOnboard
                    </Box>

                    <Box to="/reactpage" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/reactpage.png" alt="MStore Magento" />
                        ReactPage
                    </Box>

                    <Box to="/beostore" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn tc" elevation="2" radius="4">
                        <img className="w10 mb1" src="/images/logos/beoui.png" alt="MStore Magento" />
                        BeoStore
                    </Box>
*/}

                    <Box to="/products/" className="flex flex-column justify-between items-center middarkgrey pa2 pt5 pb5 tdn" elevation="2" radius="4">
                        <Icon name="more" className="w8 nudge-top--6" />
                        See More
                    </Box> 
                </div>
            </section>
        </div>
    </div>
)

export default HomeHeader
